import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';

// Loaderでのインストール
import Vuetify, { VDialog,VIcon,VSnackbar } from 'vuetify/lib';
Vue.use(Vuetify,{
  components: { VDialog,VIcon,VSnackbar },
});

//import Vuetify from 'vuetify/lib';
//Vue.use(Vuetify);

// フルインストール
//import Vuetify from 'vuetify'
//import 'vuetify/dist/vuetify.min.css'
//Vue.use(Vuetify);

import themes from '../theme'
import { appEnv } from '../tenant'
//console.log(theme);

// テーマの選択
let theme = {};
// テーマは会社の設定から選ぶ（SPEC-039）
let themeName = appEnv.VUE_APP_THEME_NAME;
if (themeName){
  theme = themes[themeName]
}
if (!theme) theme = {};


export default new Vuetify({
  theme: {
    dark: false, // dark or light はここで指定するようになった
    themes:{
      light:theme,
      dark:theme,
    },

  },
  icons: {
    iconfont: 'mdi', // // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
});
